<app-dql-create-dialog (onCreateExpression)="onCreateExpression.emit($event)" #newSearchDialog></app-dql-create-dialog>
<app-dql-stored-query-save-dialog (onQuerySavedOrDeleted)="onQuerySavedOrDeleted.emit($event)" #storedQuerySaveDialog></app-dql-stored-query-save-dialog>
